import { Component, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { AppConstants } from '../app.constants';

@Component({
    selector: 'app-pagination',
    templateUrl: 'pagination.component.html'
})

export class PaginationComponent implements OnChanges {

    /** 現在のページ番号 */
    @Input()
    public currentPage: number;

    /** 総件数 */
    @Input()
    public totalItemCount: number;

    @Input()
    public sizing: string;

    /** 1ページあたりリスト表示件数 */
    @Input()
    public perPage: number = AppConstants.PAGE_SIZE;

    /** ページを切り替えた際の通知用 */
    @Output()
    public pageChanged = new EventEmitter<number>();

    /** ページNo表示件数 */
    //@Input()
    public size: number = 5;

    /** 総ページ数 */
    public totalPages: number;

    /** 表示ページ番号リスト */
    public displayPages: number[] = [1,2,3];


    public constructor() {}


    //プロパティバインドした変数の変更を検知
    public ngOnChanges(changes: {[key: string]: SimpleChange}): void
    {
        //if (!changes['totalItemCount'].firstChange && changes.totalItemCount.previousValue && changes['totalItemCount']) {
        if (changes['totalItemCount']) {
            this.totalPages = Math.ceil(changes.totalItemCount.currentValue / this.perPage);
            this.updateDisplayPages();
        }
    }

    //ページ番号ボタン押下して移動
    public pageJump(pageNumber: number): void
    {
        this.currentPage = pageNumber;
        this.updateDisplayPages();

        // EventEmitterを通じて変更を通知
        this.pageChanged.emit(this.currentPage);
    }

    //「次へ」ボタンを押して移動
    public next(): void
    {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updateDisplayPages();
        }
    }

    //「前へ」ボタンを押して移動
    public prev(): void
    {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updateDisplayPages();
        }
    }

    //表示リスト更新
    private updateDisplayPages(): void
    {
        this.displayPages = this.calcDisplayPages();
    }

    
    //sizeを考慮して表示するべきページ配列を返却する
    private calcDisplayPages(): number[]
    {
        if (this.size >= this.totalPages) {
            return this.range(1, this.totalPages);
        }

        // 中間を求める（切り上げ）
        let mid = Math.ceil(this.size / 2);

        if (this.currentPage <= mid) {
            return this.range(1, this.size);
        }

        // 現在のページを中心に前後を埋める
        let zero = ((this.size - 1) % 2) === 0;

        let before, after;
        if (zero) {
            before = (this.size - 1) / 2;
            after = before;
        } else {
            before = Math.floor((this.size - 1) / 2);
            after = before + 1;
        }

        if (this.totalPages - after < this.currentPage) {
            return this.range(this.totalPages - this.size + 1, this.size);
        }

        let start = this.currentPage - before;

        return this.range(start, this.size);
    }

    //ページボタン配列を生成する
    private range(start: number, length: number): number[]
    {
        let arr = [];
        for (let i = start; i < start + length; i++) {
            arr.push(i);
        }

        return arr;
    }

}



// WEBPACK FOOTER //
// ./src/app/common/pagination.component.ts